import React from 'react'
import loaderSvg from '../../assets/images/loader.svg'

const Loader: React.FC = () => {
  return (
    <div className='loader'>
      <img src={loaderSvg} alt='Loading...'/>
    </div>
  )
}

export default Loader
